module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-header'), _vm._v(" "), _c('nav-bread', [_c('span', [_vm._v("OrderConfirm")])]), _vm._v(" "), _c('div', [_c('svg', {
    staticStyle: {
      "position": "absolute",
      "width": "0",
      "height": "0",
      "overflow": "hidden"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('symbol', {
    attrs: {
      "id": "icon-add",
      "viewBox": "0 0 32 32"
    }
  }, [_c('title', [_vm._v("add2")]), _vm._v(" "), _c('path', {
    staticClass: "path1",
    attrs: {
      "d": "M15 17h-13.664c-0.554 0-1.002-0.446-1.002-1 0-0.552 0.452-1 1.002-1h13.664v-13.664c0-0.554 0.446-1.002 1-1.002 0.552 0 1 0.452 1 1.002v13.664h13.664c0.554 0 1.002 0.446 1.002 1 0 0.552-0.452 1-1.002 1h-13.664v13.664c0 0.554-0.446 1.002-1 1.002-0.552 0-1-0.452-1-1.002v-13.664z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "icon-ok",
      "viewBox": "0 0 39 32"
    }
  }, [_c('title', [_vm._v("ok")]), _vm._v(" "), _c('path', {
    staticClass: "path1",
    attrs: {
      "d": "M14.084 20.656l-7.845-9.282c-1.288-1.482-3.534-1.639-5.016-0.351s-1.639 3.534-0.351 5.016l10.697 12.306c1.451 1.669 4.057 1.623 5.448-0.096l18.168-22.456c1.235-1.527 0.999-3.765-0.528-5.001s-3.765-0.999-5.001 0.528l-15.573 19.337z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "icon-edit",
      "viewBox": "0 0 32 32"
    }
  }, [_c('title', [_vm._v("edit")]), _vm._v(" "), _c('path', {
    staticClass: "path1",
    attrs: {
      "d": "M25.599 11.292l-4.892-4.892 3.825-3.825 4.892 4.892-3.825 3.825zM4.732 23.308l3.959 3.959-5.939 1.98 1.98-5.939zM10.666 26.225l-4.892-4.892 13.425-13.425 4.892 4.892-13.425 13.425zM31.687 6.713l-6.4-6.4c-0.417-0.417-1.091-0.417-1.508 0l-20.267 20.267c-0.114 0.115-0.191 0.25-0.242 0.393-0.003 0.009-0.012 0.015-0.015 0.025l-3.2 9.6c-0.128 0.383-0.029 0.806 0.257 1.091 0.203 0.204 0.476 0.313 0.754 0.313 0.112 0 0.227-0.017 0.337-0.054l9.6-3.2c0.011-0.003 0.017-0.013 0.027-0.016 0.142-0.052 0.276-0.128 0.39-0.242l20.267-20.267c0.417-0.416 0.417-1.091 0-1.508v0z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "icon-delete",
      "viewBox": "0 0 26 32"
    }
  }, [_c('title', [_vm._v("delete")]), _vm._v(" "), _c('path', {
    staticClass: "path1",
    attrs: {
      "d": "M17.723 28c0.543 0 0.984-0.448 0.984-1v-12c0-0.552-0.441-1-0.984-1s-0.985 0.448-0.985 1v12c0 0.552 0.441 1 0.985 1v0zM7.877 28c0.543 0 0.984-0.448 0.984-1v-12c0-0.552-0.441-1-0.984-1s-0.985 0.448-0.985 1v12c0 0.552 0.441 1 0.985 1v0zM12.8 28c0.543 0 0.985-0.448 0.985-1v-12c0-0.552-0.441-1-0.985-1s-0.984 0.448-0.984 1v12c0 0.552 0.441 1 0.984 1v0zM23.631 4h-5.908v-2c0-1.104-0.882-2-1.969-2h-5.908c-1.087 0-1.969 0.896-1.969 2v2h-5.908c-1.087 0-1.969 0.896-1.969 2v2c0 1.104 0.882 2 1.969 2v18c0 2.208 1.765 4 3.939 4h13.784c2.174 0 3.938-1.792 3.938-4v-18c1.087 0 1.969-0.896 1.969-2v-2c0-1.104-0.882-2-1.969-2v0zM9.846 3c0-0.552 0.441-1 0.984-1h3.938c0.544 0 0.985 0.448 0.985 1v1h-5.908v-1zM21.662 28c0 1.104-0.882 2-1.969 2h-13.784c-1.087 0-1.97-0.896-1.97-2v-18h17.723v18zM22.646 8h-19.692c-0.543 0-0.985-0.448-0.985-1s0.441-1 0.985-1h19.692c0.543 0 0.984 0.448 0.984 1s-0.441 1-0.984 1v0z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "icon-clock",
      "viewBox": "0 0 32 32"
    }
  }, [_c('title', [_vm._v("clock")]), _vm._v(" "), _c('path', {
    staticClass: "path1",
    attrs: {
      "d": "M29.333 16c0-7.364-5.97-13.333-13.333-13.333s-13.333 5.97-13.333 13.333c0 7.364 5.97 13.333 13.333 13.333s13.333-5.97 13.333-13.333v0 0 0 0 0 0zM0 16c0-8.837 7.163-16 16-16s16 7.163 16 16c0 8.837-7.163 16-16 16s-16-7.163-16-16zM14.667 14.667v1.333h2.667v-10.667h-2.667v9.333zM24 18.667h1.333v-2.667h-10.667v2.667h9.333z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "checkout-order"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "item-list-wrap confirm-item-list-wrap"
  }, [_c('div', {
    staticClass: "cart-item order-item"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "cart-item-list"
  }, _vm._l((_vm.orderList), function(item, index) {
    return (item.checked == '1') ? _c('li', [_c('div', {
      staticClass: "cart-tab-1"
    }, [_c('div', {
      staticClass: "cart-item-pic"
    }, [_c('img', {
      attrs: {
        "src": '/static/' + item.productImage,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "cart-item-title"
    }, [_c('div', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(item.productName))])])]), _vm._v(" "), _c('div', {
      staticClass: "cart-tab-2"
    }, [_c('div', {
      staticClass: "item-price"
    }, [_vm._v(_vm._s(item.salePrice))])]), _vm._v(" "), _c('div', {
      staticClass: "cart-tab-3"
    }, [_c('div', {
      staticClass: "item-quantity"
    }, [_c('div', {
      staticClass: "select-self"
    }, [_c('div', {
      staticClass: "select-self-area"
    }, [_c('span', {
      staticClass: "select-ipt"
    }, [_vm._v("×" + _vm._s(item.productNum))])])]), _vm._v(" "), _c('div', {
      staticClass: "item-stock item-stock-no"
    }, [_vm._v("In Stock")])])]), _vm._v(" "), _c('div', {
      staticClass: "cart-tab-4"
    }, [_c('div', {
      staticClass: "item-price-total"
    }, [_vm._v(_vm._s(_vm._f("currency")(item.productNum * item.salePrice, '$')))])])]) : _vm._e()
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "price-count-wrap"
  }, [_c('div', {
    staticClass: "price-count"
  }, [_c('ul', [_c('li', [_c('span', [_vm._v("Item subtotal:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.subtotal, '$')))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Shipping:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.shipping, '$')))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Discount:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.discount, '$')))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Tax:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.tax, '$')))])]), _vm._v(" "), _c('li', {
    staticClass: "order-total-price"
  }, [_c('span', [_vm._v("Order total:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.endTotal, '$')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "order-foot-wrap"
  }, [_c('div', {
    staticClass: "prev-btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn--m",
    on: {
      "click": _vm.pre_step
    }
  }, [_vm._v("Previous")])]), _vm._v(" "), _c('div', {
    staticClass: "next-btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn--m btn--red",
    on: {
      "click": _vm.next_step
    }
  }, [_vm._v("Proceed to payment")])])])])])]), _vm._v(" "), _c('nav-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title-normal"
  }, [_c('h2', {
    staticClass: "page-title-h2"
  }, [_c('span', [_vm._v("check out")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "check-step"
  }, [_c('ul', [_c('li', {
    staticClass: "cur"
  }, [_c('span', [_vm._v("Confirm")]), _vm._v(" address")]), _vm._v(" "), _c('li', {
    staticClass: "cur"
  }, [_c('span', [_vm._v("View your")]), _vm._v(" order")]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Make")]), _vm._v(" payment")]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Order")]), _vm._v(" confirmation")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title-normal checkout-title"
  }, [_c('h2', [_c('span', [_vm._v("Order content")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-item-head"
  }, [_c('ul', [_c('li', [_vm._v("Order contents")]), _vm._v(" "), _c('li', [_vm._v("Price")]), _vm._v(" "), _c('li', [_vm._v("Quantity")]), _vm._v(" "), _c('li', [_vm._v("Subtotal")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d2053f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/orderConfirm.vue
// module id = 75
// module chunks = 0